export const siteList = [
  { title: "Etusivu", url: "/", id: "site1" },
  { title: "Esittely", url: "/esittely", id: "site2" },
  { title: "Historia", url: "/historia", id: "site3"},
  { title: "Jäsenet", url: "/jäsenet", id: "site4"},
  { title: "Galleria", url: "/galleria", id: "site5"},
  { title: "Sanastoa", url: "/sanastoa", id: "site6"},
  { title: "Vieraskirja", url: "/vieraskirja", id: "site7"}
];
